export default "__VITE_ASSET__CJYtVDsw__"